import classes from "./Buttons.module.scss";
import * as btnConfig from "../../constants/buttons";

export const getBtnTypeClass = (btnType, standard = null) => {
  switch (btnType) {
    case btnConfig.BTN_TYPE_SECONDARY:
      return classes.Secondary;
    case btnConfig.BTN_TYPE_SECONDARY_WHITE:
      return classes.SecondaryWhite;
    case btnConfig.BTN_TYPE_SECONDARY_LIGHT:
      return classes.SecondaryLight;
    case btnConfig.BTN_TYPE_BORDER_SECUNDARY:
      return classes.BorderSecondary;
    case btnConfig.BTN_TYPE_TRANSPARENT:
      return classes.Transparent;
    case btnConfig.BTN_TYPE_GRAY:
      return classes.Gray;
    case btnConfig.BTN_TYPE_PRIMARY:
      return classes.Button;
    default:
      return standard ? standard : classes.Button;
  }
};

export const getBtnSize = (size) => {
  switch (size) {
    case btnConfig.BTN_SIZE_SM:
      return classes.Sm;
    case btnConfig.BTN_SIZE_MD:
      return classes.Md;
    default:
      return "";
  }
};
